import { ChevronDownIcon, ChevronUpIcon, FunnelIcon, } from "@heroicons/react/24/outline";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InputsFields from "../../helpers/InputFields";
import { ReportCallsListInputFilters } from "../../utils/listInputs/ReportCallsListInputFilter";

export const InitialValueFilterReportOp: any = {
    DataDa: moment().tz("Europe/London").format('DD-MM-YYYY'),
    DataA: moment().tz("Europe/London").format('DD-MM-YYYY'),
    IdOperatore: { value: '', label: 'Qualsiasi' },
    IdSupervisore: { value: '', label: 'Qualsiasi' }
}

export default function ReportCallsFilters({ methodParent, operatoreData, supervisoreData }: any) {

    let mapOp = operatoreData?.map((op: any) => ({ value: op?.id, label: `${op?.nominativo} (${op?.codiceUtente})` }));
    let mapSup = supervisoreData?.map((op: any) => ({ value: op?.id, label: `${op?.nominativo} (${op?.codiceUtente})` }));
    const anyOption = [{ value: '', label: 'Qualsiasi' }];
    const operatorOptions = anyOption.concat(mapOp);
    const supervisoreOptions = anyOption.concat(mapSup);
    const form = useForm({ defaultValues: InitialValueFilterReportOp });
    const [isOpenFilter, setIsOpenFilter] = useState<boolean>(true);
    const { handleSubmit, watch } = form;
    const opOperatore = watch('IdOperatore');
    const opSupervisore = watch('IdSupervisore');

    const handleSubmitFIlter = async (data: any) => {
        methodParent(data);
    }

    useEffect(() => {
        if (opSupervisore?.value) {
          form.setValue('IdOperatore', { value: '', label: 'Qualsiasi' });
        }
      }, [opSupervisore?.value]);
      
      useEffect(() => {
        if (opOperatore?.value) {
          form.setValue('IdSupervisore', { value: '', label: 'Qualsiasi' });
        }
      }, [opOperatore?.value]);

    return (
        <div className="bg-white shadow-lg rounded-lg">
            <div className="flex justify-between items-center p-4" >
                <p>Filtri</p>
                <button onClick={() => setIsOpenFilter(!isOpenFilter)}>
                    {isOpenFilter ? <ChevronUpIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
                </button>
            </div>
            {isOpenFilter && <form onSubmit={handleSubmit(handleSubmitFIlter)} >

                <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 grid-rows-none gap-6 px-4 py-2">
                    <InputsFields arrFields={ReportCallsListInputFilters(operatorOptions, supervisoreOptions)} form={form} />
                </div>

                <div className="flex items-center justify-end space-x-5 pb-5 w-full px-5 mt-4">
                    <button type="submit" className="h-10 w-52 bg-[#064e3b] text-white rounded-lg px-10 text-[15px]">
                        Download report
                    </button>
                </div>

            </form>}
        </div>
    )
}